module.exports = fox._r("images/notice-sign.png", __webpack_public_path__ + "_/_/_/common/frame/images/notice-sign.png");


//////////////////
// WEBPACK FOOTER
// /var/www/jenkins.devel.ac/workspace/MC_Frontend_Rollout/admin/common/frame/images/notice-sign.png
// module id = 100
// module chunks = 2